import { useUnsafeUpdatedRef } from "@mdotm/utils/react-extra";
import type { UseQueryResult } from "@tanstack/react-query";
import { useEffect } from "react";


export function useQueryReactor<T, E = unknown>(
	query: Pick<UseQueryResult<T, E>, "data" | "isFetching" | "isError" | "error" | "isSuccess">,
	callbacks: {
		onFetching?(): void;
		onSuccess?(data: T): void;
		onError?(err: E): void;
	}
): void {
	const callbacksRef = useUnsafeUpdatedRef(callbacks);
	useEffect(() => {
		if (query.isFetching) {
			callbacksRef.current.onFetching?.();
		} else if (query.isError) {
			callbacksRef.current.onError?.(query.error!);
		} else if (query.isSuccess) {
			callbacksRef.current.onSuccess?.(query.data!);
		}
	}, [query.isFetching, query.isSuccess, query.isError, query.data, query.error, callbacksRef]);
}